import type { SVGProps } from 'react';

export function Branding({ className = '', ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* big circle mark */}
      <circle cx="140" cy="150" r="60" />
      <circle cx="140" cy="150" r="24" fill="#E7FF4D" stroke="none" />

      {/* color swatches */}
      <rect x="230" y="100" width="40" height="40" />
      <rect x="280" y="100" width="40" height="40" fill="#E7FF4D" stroke="none" />
      <rect x="230" y="150" width="40" height="40" />
      <rect x="280" y="150" width="40" height="40" />

      {/* type specimen */}
      <line x1="60" y1="250" x2="340" y2="250" />
      <text x="60" y="295" fontFamily="serif" fontSize="48" fontWeight="700" fill="currentColor" stroke="none">
        Aa Bb
      </text>
      <text x="210" y="295" fontFamily="monospace" fontSize="18" fill="currentColor" stroke="none">
        AaBbCcDd
      </text>
      <line x1="60" y1="320" x2="340" y2="320" />
      <text x="60" y="345" fontFamily="monospace" fontSize="10" fill="#E7FF4D" stroke="none">
        FRAUNCES / GEIST MONO
      </text>
    </svg>
  );
}
